import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AplicationComponent } from './aplication.component';
import { MaterialModule } from 'src/app/material.module';

@NgModule({
  declarations: [AplicationComponent],
  imports: [CommonModule, MaterialModule],
  exports: [AplicationComponent],
})
export class ApplicationModule {}
